"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NChangedGroupOfSites_1 = require("../model/NChangedGroupOfSites");

var NChangedGroupOfSitesConverter_1 = require("./NChangedGroupOfSitesConverter");
/**
 * @author Tomas Leity
 */


var NChangedGroupOfSitesConverterImpl =
/*#__PURE__*/
function (_NChangedGroupOfSites) {
  _inherits(NChangedGroupOfSitesConverterImpl, _NChangedGroupOfSites);

  function NChangedGroupOfSitesConverterImpl() {
    _classCallCheck(this, NChangedGroupOfSitesConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedGroupOfSitesConverterImpl).apply(this, arguments));
  }

  _createClass(NChangedGroupOfSitesConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NChangedGroupOfSites_1.NChangedGroupOfSites(NChangedGroupOfSites_1.NChangedGroupOfSites.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NChangedGroupOfSites_1.NChangedGroupOfSites.schema.productName.valueOf(source.productName), NChangedGroupOfSites_1.NChangedGroupOfSites.schema.newGroupOfSitesId.valueOf(conversions.toClassReferenceId(source.newGroupOfSitesId)), NChangedGroupOfSites_1.NChangedGroupOfSites.schema.newGroupOfSitesName.valueOf(source.newGroupOfSitesName), NChangedGroupOfSites_1.NChangedGroupOfSites.schema.oldGroupOfSitesId.valueOf(conversions.toClassReferenceId(source.oldGroupOfSitesId)), NChangedGroupOfSites_1.NChangedGroupOfSites.schema.oldGroupOfSitesName.valueOf(source.oldGroupOfSitesName));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        newGroupOfSitesId: conversions.toDocumentReferenceId(source.newGroupOfSitesId),
        newGroupOfSitesName: source.newGroupOfSitesName,
        oldGroupOfSitesId: conversions.toDocumentReferenceId(source.oldGroupOfSitesId),
        oldGroupOfSitesName: source.oldGroupOfSitesName
      });
      return result;
    }
  }]);

  return NChangedGroupOfSitesConverterImpl;
}(NChangedGroupOfSitesConverter_1.NChangedGroupOfSitesConverter);

exports.NChangedGroupOfSitesConverterImpl = NChangedGroupOfSitesConverterImpl;
/**
 * IOC Container qualifier
 */

NChangedGroupOfSitesConverterImpl.QUALIFIER = {
  documentType: NChangedGroupOfSites_1.NChangedGroupOfSites.name
};